import React from "react";
import { EVENT } from "@/lib/landingConfig";

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="footer"
      className="bg-[#3F403A] text-[#FAF8F3]/90"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-14 md:py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-6">
          <img
            src="https://customer-assets.emergentagent.com/job_lidera-voz-propia/artifacts/ubdos91d_1.png"
            alt="Lidera con Voz Propia"
            className="h-20 md:h-24 w-auto object-contain -ml-2"
            loading="lazy"
            data-testid="footer-logo"
          />
          <p className="mt-4 overline text-[#FAF8F3]/60">
            {EVENT.date} · {EVENT.city}
          </p>
          <p className="mt-6 max-w-md font-sans text-sm text-[#FAF8F3]/70 leading-relaxed">
            Ecosistema de transformación empresarial femenino que integra
            liderazgo, comunicación, visibilidad y relacionamiento estratégico.
          </p>
          <div className="mt-8 flex items-center gap-5">
            <img
              src="https://customer-assets.emergentagent.com/job_lidera-voz-propia/artifacts/7wmueq1h_1.png"
              alt="Esther Parejo"
              className="h-16 md:h-20 w-auto object-contain -ml-2"
              style={{ filter: "invert(1)", mixBlendMode: "lighten" }}
              loading="lazy"
              data-testid="footer-logo-esther"
            />
            <div className="border-l border-[#FAF8F3]/25 pl-5">
              <p className="overline text-[#FAF8F3]/60">Dirección</p>
              <p className="mt-1 font-serif text-lg text-[#FAF8F3]">Esther Parejo</p>
            </div>
          </div>
        </div>

        <nav className="md:col-span-3 md:col-start-8">
          <p className="overline text-[#FAF8F3]/60 mb-4">Explorar</p>
          <ul className="space-y-3 font-sans text-sm">
            <li><a href="#experiencia" className="hover:text-[#F4EFE7]/100 text-[#FAF8F3]/80 transition-colors" data-testid="footer-link-experiencia">La jornada</a></li>
            <li><a href="#ponentes" className="hover:text-[#F4EFE7]/100 text-[#FAF8F3]/80 transition-colors" data-testid="footer-link-ponentes">Ponentes</a></li>
            <li><a href="#inscripcion" className="hover:text-[#F4EFE7]/100 text-[#FAF8F3]/80 transition-colors" data-testid="footer-link-inscripcion">Inscripción</a></li>
            <li><a href="#faq" className="hover:text-[#F4EFE7]/100 text-[#FAF8F3]/80 transition-colors" data-testid="footer-link-faq">Preguntas</a></li>
          </ul>
        </nav>

        <div className="md:col-span-3">
          <p className="overline text-[#FAF8F3]/60 mb-4">Contacto</p>
          <ul className="space-y-3 font-sans text-sm text-[#FAF8F3]/80">
            <li><a href="#info" className="hover:text-[#F4EFE7]/100 transition-colors" data-testid="footer-link-info">Solicitar información</a></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-[#FAF8F3]/12">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-[#FAF8F3]/60">
          <p>© {year} Lidera con Voz Propia. Todos los derechos reservados.</p>
          <p className="overline">Edición Nº 04</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
